import { IUsuario } from '@/@types/Comunidade';
import { DocenteItem } from '@/components/PagesComponents/Comunidade/DocenteItem';
import { Loading } from '@/components/shared/Loading';
import { api } from '@/services/api';

import { useEffect, useState } from 'react';

interface IDocente extends IUsuario {
}

const CorpoDocente = () => {
    const [docentes, setDocentes] = useState<IDocente[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(true);

    useEffect(() => {

        const getDocentes = async () => {
            setIsLoading(true);
            const url = '/user/register/allUser/Docentes'
            await api.get(url)
                .then(response => {
                    setDocentes(response.data);
                })
                .catch(err => {
                    console.log(err);
                })
                .finally(() => {
                    setIsLoading(false);
                })
        }

        getDocentes();

    }, []);

    return (
        <>
            <h1>Corpo Docente</h1>

            {isLoading ? (
                <Loading color='primary' />
            ) : (
                <div>
                    {docentes.map(docente => {
                        return (
                            <DocenteItem key={docente._id} data={docente} />
                        )
                    })}
                </div>
            )}
        </>
    );
}

export { CorpoDocente };